import { useEffect, useState } from 'react';

/**
 * Returns the latest value only after it has stopped changing for `delayMs`.
 * Used to throttle search-as-you-type API calls.
 */
const useDebounce = <T>(value: T, delayMs = 300): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedValue(value);
    }, delayMs);

    return () => {
      clearTimeout(timeout);
    };
  }, [value, delayMs]);

  return debouncedValue;
};

export default useDebounce;
